module.exports = __webpack_public_path__ + "img/tongchui.25ccad95.jpg";